// extracted by mini-css-extract-plugin
module.exports = {"root":"OverviewTab_root__3sNfo","card":"OverviewTab_card__5ahp9","loading":"OverviewTab_loading__3c6Yr"};